import React, { useEffect } from 'react';
import { useSetResolved } from 'src/core/engine/router';
import { DelayedRedirect } from 'src/core/engine/router/DelayedRedirect';
import { FreeReturns } from 'src/components/FreeReturns/FreeReturns';
import { useHeadTags, escapeAttr } from 'src/core/engine/head';
import { FREE_SHIPPING } from 'src/constants/meta';
import { useIsIrishUser } from 'src/util/cookies';

import { Container, Wrapper } from '../../components/Layout';

import '../../scss/_root-component.scss';

export const FreeReturnsRoot: React.FC = () => {
    useSetResolved();
    const { setHead } = useHeadTags();
    const isIrishUser = useIsIrishUser();

    useEffect(() => {
        if (isIrishUser) return;
        const title = `FREE RETURNS, Always! ✓ FREE DELIVERY Over ${FREE_SHIPPING} | Workwear Express`;
        const description = `FREE RETURNS at Workwear Express, UK. 2 million free Happy Customers. Your satisfaction, our priority. ✓ 24 Hour Dispatch ✓ Free Delivery Over ${FREE_SHIPPING}`;
        setHead({
            title: `<title>${escapeAttr(title)}</title>`,
            meta: `<meta name="description" content="${escapeAttr(description)}" />`,
        });
    }, [isIrishUser, setHead]);

    if (isIrishUser) {
        return <DelayedRedirect to="/returns" />;
    }

    return (
        <Wrapper variant="widget-wrapper-no-padding">
            <Container>
                <FreeReturns />
            </Container>
        </Wrapper>
    );
};

export default FreeReturnsRoot;
